import { useEffect, useMemo } from "react";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import ChecklistColumn from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/CaseSummaryV2/Sections/ChecklistColumn";
import InvolvedIndividuals from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/CaseSummaryV2/Sections/InvolvedIndividuals";
import LostButton from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/CaseSummaryV2/Sections/LostButton";
import DynamicForm from "../../../../../components/modules/ClientDetail/Case/DynamicForm";
import InvalidContent from "../../../../../components/modules/ClientDetail/Case/DynamicForm/components/InvalidContent";
import { mapPermissions } from "../../../../../components/modules/ClientDetail/Case/utils/functions";
import { generalLayout } from "../../../../../components/modules/ClientDetail/Case/utils/layouts";
import { generalTabDataMapper } from "../../../../../components/modules/ClientDetail/Case/utils/mappers";
import Navigation from "../../../../../components/navigations/client/detail/case/navigation";
import HNSColors from "../../../../../components/ui library/HNSColors";
import useMedicalCompleteLock from "../../../../../hooks/useMedicalCompleteLock";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case, _caseHistory } = useParentLoaderData(2);
  const currentUserService = inject("current-user-service");
  const caseRepository = useService("repositories/case-repository");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canEdit = userPermissions.includes("casemanager.change_case");
  const canView = userPermissions.includes("casemanager.view_case");
  const canViewCampaignField = userPermissions.includes("leads.view_campaign");
  const { isCaseStatusLocked } = useMedicalCompleteLock();

  const initialLayout = [
    ...generalLayout.map((section, index) => {
      if (index === 3 && canViewCampaignField) {
        return {
          row: [
            ...(section?.row?.length ? section.row : []),
            {
              label: "Campaign:",
              type: "select",
              name: "campaign",
              optionsURL: "leads/campaigns/?ordering=name",
              permissions: [],
              required: false,
            },
          ],
        };
      }
      return section;
    }),
    {
      row: [
        {
          label: "Incident Description:",
          type: "textarea",
          name: "incidentDescription",
          required: false,
          rows: 2,
        },
      ],
    },
  ];

  const mappedLayout = mapPermissions(
    initialLayout,
    canEdit,
    isCaseStatusLocked(_case) ? ["status"] : []
  );
  const mappedCase = useMemo(() => generalTabDataMapper(_case), [_case]);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/case/general");
  }, []);

  return (
    <Navigation activeTab="general" _case={_case}>
      {canView ? (
        <DynamicForm
          formLayout={mappedLayout}
          data={mappedCase}
          historyData={_caseHistory}
          lostReason={_case?.lost?.reason ?? null}
          formRepository={caseRepository}
          extraComponent={
            <div className="grid w-full grid-cols-2 gap-4 pt-6">
              <ChecklistColumn
                caseObj={_case}
                editPermissions={canEdit}
                viewPermissions={canView}
              />
              <div
                style={{ border: `1px solid ${HNSColors.secondary[900]}` }}
                className="h-fit w-full rounded-md p-2"
              >
                <InvolvedIndividuals
                  caseObj={_case}
                  editPermissions={canEdit}
                  viewPermissions={canView}
                />
              </div>
            </div>
          }
          extraButton={<LostButton caseObj={_case} />}
        />
      ) : (
        <InvalidContent />
      )}
    </Navigation>
  );
};
